import './green-bond-page.scss';

/**
 * version    1.0
 * class      <type> (Green Bond Page)
 * classdesc  contains the logic for the green bond page
 */
export class GreenBondPage {}
